
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.articles-filter-accordion__item-title' ).click( function() {
        if ( $( this ).closest( '.articles-filter-accordion__item' ).hasClass( 'is-open' ) ) {
          $( this ).closest( '.articles-filter-accordion__item' ).find( '.articles-filter-accordion__item-content' ).slideUp();
          $( this ).closest( '.articles-filter-accordion__item' ).removeClass( 'is-open' );
          $( this ).closest( '.articles-filter-accordion__item' ).find( '.accordion-trigger' ).attr( 'aria-expanded', false );
        } else {
          $( '.articles-filter-accordion__item.is-open .articles-filter-accordion__item-content' ).slideUp();
          $( '.articles-filter-accordion__item' ).removeClass( 'is-open' ).not( $( this ).closest( '.articles-filter-accordion__item' ) ).find( '.accordion-trigger' ).attr( 'aria-expanded', false );
          $( this ).closest( '.articles-filter-accordion__item' ).find( '.articles-filter-accordion__item-content' ).slideDown();
          $( this ).closest( '.articles-filter-accordion__item' ).find( '.accordion-trigger' ).attr( 'aria-expanded', true );
          $( this ).closest( '.articles-filter-accordion__item' ).addClass( 'is-open' );
        }
      } );

      $( document ).on( 'updateLargeMediaQuery', ( event ) => {
        $( '.articles-filter-accordion__item-content' ).each( function( index ) {
          $( this ).css( 'display', '' );
        } );

        $( '.articles-filter-accordion__item' ).each( function() {
          $( this ).removeClass( 'is-open' );
        } );
      } );

      // Article filter functions
      if ( window.location.search ) {
        filterArticles( new URLSearchParams( window.location.search ).toString() );
      }

      function getPathFromUrl( url ) {
        return url.split( '?' )[0];
      }

      // Clear filter button
      $( '.clear-filter-btn' ).on( 'click', ( event ) => {
        event.preventDefault();

        // get url
        const currentLocation = $( location ).attr( 'href' );
        const newLocation = getPathFromUrl( currentLocation );

        history.replaceState( '', '', newLocation );

        // clear inputs
        $( '.articles-filter__input' ).prop( 'checked', false );

        // clear out filter buttons
        $( '.articles-filter__selected' ).empty();

        // reset filter to default
        $( '#articles-sort' ).val( 'date_asc' ).change();

        // run new query to retrieve all articles
        const formData = new FormData( );
        const urlQuery = new URLSearchParams( formData ).toString();
        filterArticles( urlQuery );
      } );

      // Search button click
      $( '#articles-sort' ).on( 'change', function() {
        $( '#filter-btn' ).click();
      } );

      // Form submits
      $( '#article-filter' ).on( 'submit', function( event ) {
        event.preventDefault();

        // check where the submit request came from and if it was from the search button it clears the form and only does a search
        const submitID = $( event.originalEvent.submitter ).attr( 'id' );

        if ( submitID === 'submit-btn' ) {
          // get the form data
          const formData = new FormData( event.target );
          const searchTerm = formData.get( 'search' );

          // clear form and fitler inputs
          // clear inputs
          $( '.articles-filter__input' ).prop( 'checked', false );

          // clear out filter buttons
          $( '.articles-filter__selected' ).empty();

          // reset filter to default
          $( '#articles-sort' ).val( 'date_asc' ).change();

          // Create a search with only the form data
          const searchFormData = new FormData( );
          searchFormData.set( 'search', searchTerm );

          // clear url of all previous searches and add only search
          const urlQuery = new URLSearchParams( searchFormData ).toString();
          history.replaceState( '', '', '?'+decodeURIComponent( urlQuery ) );
          filterArticles( urlQuery );
          return;
        }

        // Submit filter
        const formData = new FormData( event.target );
        const urlQuery = new URLSearchParams( formData ).toString();
        history.replaceState( '', '', '?'+decodeURIComponent( urlQuery ) );
        filterArticles( urlQuery );
        return;
      } );

      /* Articles Filter Function */
      function filterArticles( query ) {
        let doingAjax = false;
        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'articles/filter', // note that articles/filter is the path set in our new route in routes.php
          data: query,
          beforeSend: function( xhr ) {
            $( '.articles-main' ).addClass( 'loading' );
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            if ( data.articles.length !== 0 ) {
              $( '.articles-main' ).html( data.articles );
              if ( data.pagination ) {
                $( '.pagination' ).html( data.pagination );
              }
              if ( data.display_count ) {
                $( '.articles__display' ).text( data.display_count );
              }
            } else {
              $( '.articles-main' ).html( data.no_result );
              $( '.pagination' ).empty();
              $( '.articles__display' ).text( 'Displaying 0-0 of 0 results' );
            }
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
            $( '.articles-main' ).removeClass( 'loading' );
          },
        } );
      }

      $( '.articles-filter__input' ).on( 'change', function() {
        // adds padding to container when not empty
        if ( !$( '.articles-filter__selected-container' ).hasClass( 'selection' ) ) {
          $( '.articles-filter__selected-container' ).addClass( 'selection' );
        }

        // get the value and text for filter button
        const value = $( this ).val();
        const text = $( this ).next().find( '.articles-filter__title' ).text();

        // check if its a date button and if so make sure the others are unclicked
        if ( $( this ).attr( 'name' ) === 'query_date[]' ) {
          if ( $( this ).is( ':checked' ) ) {
            // the name of the box is retrieved using the .attr() method
            // as it is assumed and expected to be immutable
            const group = 'input:checkbox[name=\'' + $( this ).attr( 'name' ) + '\']';

            // the checked state of the group/box on the other hand will change
            // and the current value is retrieved using .prop() method
            $( group ).prop( 'checked', false );
            $( this ).prop( 'checked', true );
          } else {
            $( this ).prop( 'checked', false );
          }
        }
        // check if the button already exists
        if ( $( `:button[value="${value}"]` ).length ) {
          $( `:button[value="${value}"]` ).remove();
        } else {
          if ( $( this ).attr( 'name' ) === 'query_date[]' ) {
            if ( $( `:button` ).hasClass( 'date-btn' ) ) {
              $( '.date-btn' ).remove();
            }
            $( '.articles-filter__selected' ).append( `<button type="button" value="${value}" class="date-btn mb-3 mr-3 article-filter__selected-btn btn-tag">${text}<svg class="icon icon-tag-delete-x"><use xlink:href="#icon-tag-delete-x"></use></svg></button>` );
          } else {
            $( '.articles-filter__selected' ).append( `<button type="button" value="${value}" class="mb-3 mr-3 article-filter__selected-btn btn-tag">${text}<svg class="icon icon-tag-delete-x"><use xlink:href="#icon-tag-delete-x"></use></svg></button>` );
          }
        }
      } );

      // Add event listenter to dynmically created buttons
      const addSelectedListener = () => {
        $( '.articles-filter__selected' ).on( 'click', '.article-filter__selected-btn', function() {
          // removes padding when box is empty
          if ( $( '.articles-filter__selected' ).children().length < 2 ) {
            $( '.articles-filter__selected-container' ).removeClass( 'selection' );
          }
          const value = $( this ).val( );
          $( `input[value="${value}"]` ).prop( 'checked', false );
          $( this ).remove();
        } );
      };

      addSelectedListener();

      // Add click event to pagination numbers
      document.body.addEventListener( 'click', function( event ) {
        const btn = event.target;

        const value = $( btn ).attr( 'data-value' );

        if ( btn.classList.contains( 'page-numbers', 'articles-nav-btn' ) ) {
          const urlQuery = new URLSearchParams( window.location.search );
          urlQuery.set( 'page', value );
          history.replaceState( '', '', '?'+decodeURIComponent( urlQuery.toString() ) );
          filterArticles( urlQuery.toString() );
          location.href = '#articles-top'; // pagination navigation only
        }
      } );
    },
    finalize: function() {

    },
  };
  app.registerComponent( 'articles', COMPONENT );
} )( app );
